import { Typography } from '@mui/material';

import { semibold } from '@styles/fontWeights';

import useAccountStrength from '../hooks/useAccountStrength';

const AccountStrength = () => {
  const { label, color } = useAccountStrength();

  return (
    <Typography
      variant="h2"
      component="p"
      color="secondary.main"
      ml={1}
      fontWeight={semibold}
    >
      Hiring Strength:
      <Typography variant="inherit" component="span" color={color} ml={1}>
        {label}
      </Typography>
    </Typography>
  );
};

export default AccountStrength;
